import { environment } from '../../../environments/environment';

export class Endpoints {
  public static readonly REMIC_SETTLE_DATE_INFO_ENDPOINT: string =
    environment.awsBaseUrl + 'remic/remic-settle-date-info';
  public static readonly REMIC_REVIEW_SCHEDULE_ENDPOINT: string =
    environment.awsBaseUrl + 'remic/remic-date-cycle';
  public static readonly REMIC_SAVE_ENDPOINT: string =
    environment.awsBaseUrl + 'remic/remic-commit';
  public static readonly REMIC_LIST_SETTLED_ENDPOINT: string =
    environment.awsBaseUrl + 'remic/remic-list-settled';
  public static readonly REMIC_LIST_COMMITTED_ENDPOINT: string =
    environment.awsBaseUrl + 'remic/remic-list-committed';
  public static readonly UPF_UPLOAD_LOCATION_ENDPOINT: string =
    '/cdx-filupldproc/fileupload/processing/upload/url';
  public static readonly UPF_UPLOAD_STATUS_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/remic/file';
  public static readonly UPF_REMIC_UPLOAD_STATUS_ENDPOINT: string =
    environment.baseUrl + 'remicFileDownload';
  public static readonly REMIC_TRANSACTION_ENDPOINT: string =
    environment.awsUploadPoolBaseUrl + 'poolinfo/remic/transaction';
  public static readonly MODEL_ENGINE: string = environment.modelEngineBaseUrl;
  public static readonly GET_INPUT_FILES: string =
    environment.modelEngineBaseUrl + 'deal/cash-flow-model/input-files?';
  public static readonly GET_OUTPUT_FILES: string =
    environment.modelEngineBaseUrl + 'deal/cash-flow-model/output-files?';
  public static readonly WAL_TIE_OUT_REPORT: string = environment.walTieOut + 'wal-tie-out?';
  public static readonly DEC_TIE_OUT_REPORT: string = environment.walTieOut + 'dec-tie-out?';
  public static readonly DEC_TIE_OUT_OVERRIDE: string = environment.walTieOut + 'dec-tie-out';
  public static readonly PRICING_WAL_TIE_OUT_REPORT: string =
    environment.walTieOut + 'pricing-wal-tie-out?';
  public static readonly PRICING_WAL_TIE_OUT_OVERRIDE: string =
    environment.walTieOut + 'pricing-wal-tie-out';
  public static readonly OVERRIDE_COMMENTS_HISTORY: string =
    environment.walTieOut + 'override-comments-history?';
}
